import { TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import type { AccuracyCardProps } from './AccuracyCard';

const MobileAccuracyCard = ({
  heading,
  icon: Icon,
  note,
  percentage,
}: AccuracyCardProps): JSX.Element => {
  const t = useTranslations();
  return (
    <div
      className="flex flex-col items-center gap-y-4 border-b-2 border-b-gray-300 py-9 text-gray-400 last:border-0"
      data-cy="mobile-accuracy-card"
    >
      <div className="size-6 text-sandstone-500">
        <Icon width={24} height={24} />
      </div>
      <TypographyV3 className="text-heading-2xl" font="serif" weight="light">
        {percentage.toLocaleString(undefined, { style: 'percent' })}
      </TypographyV3>
      <TypographyV3 variant="body-large" color="dark">
        {t.rich(heading)}
      </TypographyV3>
      {note && (
        <TypographyV3 color="inherit" variant="body-small">
          {t.rich(note)}
        </TypographyV3>
      )}
    </div>
  );
};

export default MobileAccuracyCard;
